export default __webpack_public_path__ + "static/parquet-6017ac475b5d98114648de8d92a3e1a3.jpeg";